import { Navigate, Outlet, useSearchParams } from "react-router";

import { useAuthStore } from "@/client/stores/auth";
import { Role } from "@reactive-resume/utils";

export const GuestGuard = () => {
  //const isLoggedIn = useAuthStore((state) => !!state.user);
  const isLoggedIn = useAuthStore((state) => {
    if (state.user?.role === Role.ExtenalUser) return !!state.user;
    return false;
  });
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect") ?? "/client/user-space";

  if (isLoggedIn) {
    return <Navigate to={redirect} />;
  }

  return <Outlet />;
};
